import { cloneDeep } from "lodash";

import { SchedulerHelper } from "@/Appointments/Helpers/SchedulerHelper";
import { CalendarSlotV2 } from "@/Appointments/Models/Scheduling/WorkDayV2";
import { ICreateTemplateTabModel } from "@/Appointments/Models/UI/Scheduling/ICreateTemplateTabModel";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { Combobox } from "@/Common/Components/Inputs/Combobox";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { TimeSelector } from "@/Common/Components/Inputs/TimeSelector";
import { Popup } from "@/Common/Components/Modals/Popup";
import { SearchableItemModelT } from "@/Common/Models/SearchableItem";
import { ServiceDefinitionModel } from "@/Common/Models/Services/ServiceDefinitionModel";
import { SitesModel } from "@/Common/Models/Sites/SitesModel";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { AppointmentSchedulerV2 } from "./AppointmentSchedulerV2";
import { EditServiceOptions } from "./EditServiceOptions";
import { OpenSheduleType } from "./OpenScheduleTab";
import { RulesetEditComponent, RulesetEditComponentDTO } from "./RulesetEditComponent";
import { SearchComboServiceComponent } from "./SearchComboServiceComponent";

import styles from "./CreateTemplateTab.module.scss";

interface ICreateTemplateTabViewProps {
    Model: ICreateTemplateTabModel;
}

class CreateTemplateTabViewState {
    public SelectedService: ServiceDefinitionModel;
    public ServicesFiltered: Immutable.List<SearchableItemModelT<ServiceDefinitionModel>> = Immutable.List([]);

    public MinErrorPopupOpen: boolean;
    public MaxErrorPopupOpen: boolean;

    constructor(s?: CreateTemplateTabViewState) {
        if (s != null) {
            this.SelectedService = s.SelectedService;
            this.ServicesFiltered = s.ServicesFiltered;
            this.MinErrorPopupOpen = s.MinErrorPopupOpen;
            this.MaxErrorPopupOpen = s.MaxErrorPopupOpen;
        }
    }
}

class CreateTemplateTabView extends React.Component<ICreateTemplateTabViewProps, CreateTemplateTabViewState> {
    private LeftSide: React.CSSProperties = { marginLeft: "20px", marginTop: "20px", width: "920px", textAlign: "left" };
    private Middle: React.CSSProperties = { marginLeft: "20px", marginTop: "50px", width: "150px", textAlign: "center" };
    private RightSide: React.CSSProperties = { marginLeft: "25px", marginTop: "20px", width: "100%", textAlign: "left" };

    // Left Side Columns
    private c1: React.CSSProperties = { marginLeft: "10px", width: "80px", textAlign: "right", minWidth: "100px" };
    private c2: React.CSSProperties = { marginLeft: "10px", width: "424px" };

    private row: React.CSSProperties = { marginBottom: "5px", display: "flex" };
    private divlabel: React.CSSProperties = { display: "flex", flexDirection: "column", justifyContent: "center", height: "38px" };
    private label: React.CSSProperties = { margin: "0px" };

    constructor(props: ICreateTemplateTabViewProps) {
        super(props);

        if (schedulingStore.currentTemplateState == null) {
            const initialState = new CreateTemplateTabViewState();
            initialState.SelectedService = null;
            initialState.ServicesFiltered = this.getServicesFilteredBySiteId(this.props.Model.get("SelectedSiteId"));
            initialState.MinErrorPopupOpen = false;
            initialState.MaxErrorPopupOpen = false;

            this.state = initialState;
        }
        else {
            this.state = schedulingStore.currentTemplateState;
        }
    }

    public componentDidMount(): void {
        window.setTimeout(() => {
            $(window).trigger("resize");
            $("#new_template_starttime").parent().css({ width: "78px" });
            $("#new_template_endtime").parent().css({ width: "78px" });
        }, 150);
    }

    public componentDidUpdate(prevProps: ICreateTemplateTabViewProps): void {
        $(window).trigger("resize");
        $("#new_template_starttime").parent().css({ width: "78px" });
        $("#new_template_endtime").parent().css({ width: "78px" });

        const previousSiteId = prevProps.Model.get("SelectedSiteId");
        const currentSiteId = this.props.Model.get("SelectedSiteId");

        if (previousSiteId !== currentSiteId) {
            this.mutateState(state => {
                state.ServicesFiltered = this.getServicesFilteredBySiteId(currentSiteId);
            });
        }
    }

    public componentWillUnmount(): void {
        schedulingStore.currentTemplateState = this.state;
        LocalEvent.Dispatch(LocalOperations.CreateTemplateTab.ClearModel);
    }

    public render(): JSX.Element {
        var self = this;

        return (
            <div className="workspace">
                <div className="fxheight hide-overflow">
                    {this.props.Model.get("OpenAddServicePopup") === true && (
                        <Popup cssClass="double-booking" draggable={true} onCloseDelegate={this.onAddServicesPopupClick.bind(this)} title={cacheStore.GetString("AddServicesLabel")} dataCy="template-addServices-popup">
                            <div className="p-body">
                                <SearchComboServiceComponent
                                    selectedComboServiceList={this.props.Model.get("ComboServiceList")}
                                    comboServiceListSelectionChangeOperation={LocalOperations.CreateTemplateTab.ChangeComboServiceSelection}
                                    isFromOpenSchedule={false}
                                    selectedSiteId={this.props.Model.get("SelectedSiteId")}
                                />
                            </div>
                            <div className="p-footer flex-display flex-end">
                                <ButtonGroup>
                                    <ButtonControl
                                        variant="neutral"
                                        onClick={this.onAddServicesPopupClick.bind(this)}
                                        label={cacheStore.GetString("CancelLabel")}
                                    />
                                    <ButtonControl
                                        variant="brand"
                                        onClick={this.onAddServiceClick.bind(this)}
                                        label={cacheStore.GetString("AddLabel")}
                                    />
                                </ButtonGroup>
                            </div>
                        </Popup>
                    )}
                    {self.state.MinErrorPopupOpen === true && (
                        <Popup
                            cssClass="double-booking"
                            draggable={true}
                            onCloseDelegate={this.closeMinErrorPopup.bind(this)}
                            title={cacheStore.GetString("WarningLabel")}
                        >
                            <div className="p-body">
                                <label>{cacheStore.GetString("MinRuleSetErrorLabel")}</label>
                            </div>
                            <div className="p-footer flex-display flex-end">
                                <ButtonControl
                                    variant="neutral"
                                    onClick={this.closeMinErrorPopup.bind(this)}
                                    label={cacheStore.GetString("ContinueLabel")}
                                />
                            </div>
                        </Popup>
                    )}
                    {self.state.MaxErrorPopupOpen === true && (
                        <Popup
                            cssClass="double-booking"
                            draggable={true}
                            onCloseDelegate={this.closeMaxErrorPopup.bind(this)}
                            title={cacheStore.GetString("WarningLabel")}
                        >
                            <div className="p-body">
                                <label>{cacheStore.GetString("MaxRuleSetErrorLabel")}</label>
                            </div>
                            <div className="p-footer flex-display flex-end">
                                <ButtonControl
                                    variant="neutral"
                                    onClick={this.closeMaxErrorPopup.bind(this)}
                                    label={cacheStore.GetString("ContinueLabel")}
                                />
                            </div>
                        </Popup>
                    )}
                    {this.renderHeaderRow()}

                    <div className="fixed">
                        <div className="flex-container" style={{ justifyContent: "space-between", width: "100%" }}>
                            {this.renderLeft()}

                            {this.renderMiddle()}

                            {this.renderRight()}

                        </div>
                    </div>
                </div>
                <div className="ws-footer table-pager-footer" style={{ height: "0px", padding: "0px", margin: "0px" }} />
            </div>
        );
    }

    private renderLeft(): JSX.Element {
        var self = this;
        var s = this;

        return (
            <div style={s.LeftSide}>
                <div style={s.row}>
                    <div style={s.c1}>
                        <div style={s.divlabel}><label style={s.label}>{cacheStore.GetString("NameLabel")}</label></div>
                    </div>
                    <div style={s.c2}>

                        <TextboxControl
                            value={this.props.Model.get("Name")}
                            onAutoCompleteSelectClearTextBox={false}
                            style={{ marginRight: "10px" }}
                            placeholder=""
                            onMountFocus={true}
                            operation={LocalOperations.CreateTemplateTab.OnNameChange}
                            valid={!IsNullOrWhiteSpace(this.props.Model.get("Name"))}
                            dataCy="template-name"
                        />
                    </div>
                </div>
                {cacheStore.SiteCache.length > 1 && (
                    <div style={s.row}>
                        <div style={s.c1}>
                            <div style={s.divlabel}><label style={s.label}>{cacheStore.GetString("SiteDLabel")}</label></div>
                        </div>
                        <div style={s.c2}>
                            <Combobox
                                HasEmptyItem={false}
                                id="_SiteComboBox"
                                items={cacheStore.SiteCache.map(x => SitesModel.ToComboboxItem(x)).toImmutable()}
                                selectedCode={this.props.Model.get("SelectedSiteId")}
                                onChange={(selectedId: string) => {
                                    self.mutateState((_state: CreateTemplateTabViewState) => {
                                        _state.ServicesFiltered = this.getServicesFilteredBySiteId(selectedId);
                                        _state.SelectedService = null;
                                    });
                                    var op = new LocalEvent(LocalOperations.CreateTemplateTab.OnSiteChange);
                                    op.AddItem("value", selectedId);
                                    LocalEventDispatcher.dispatch(op);
                                }}
                                dataCy="template-site"
                            />
                        </div>
                    </div>
                )}
                <div style={s.row}>
                    <div style={s.c1}>
                        <div style={s.divlabel}>
                            <label style={s.label}>{cacheStore.GetString("TypeLabel")}</label>
                        </div>
                    </div>
                    <div style={s.c2}>
                        <Combobox
                            HasEmptyItem={false}
                            id="_TypeComboBox"
                            items={this.props.Model.get("CreateScheduleTypeCodeList")}
                            selectedCode={this.props.Model.get("CreateScheduleTypeCode")}
                            onChange={this.onTypeChange.bind(this)}
                            dataCy="template-type"
                        />
                    </div>
                </div>
                <div style={s.row}>
                    <div style={s.c1}>
                        <div style={s.divlabel}>
                            <label style={s.label}>{cacheStore.GetString("FromLabel")}</label>
                        </div>
                    </div>
                    <div style={s.c2}>
                        <div className="flex-container" style={{ justifyContent: "flex-start" }}>
                            <div style={{ width: "120px" }}>
                                <TimeSelector
                                    interval={5}
                                    id="new_template_starttime"
                                    cssClass="rounded"
                                    date={this.props.Model.get("HourStart")}
                                    disabled={false}
                                    onSelectOp={LocalOperations.CreateTemplateTab.OnHourStartChange}
                                    isRequired
                                    dataCy="template-from"
                                />
                            </div>
                            <div style={s.divlabel}>
                                <label style={s.label}>{cacheStore.GetString("ToLabel")}</label>
                            </div>
                            <div style={{ marginLeft: "10px" }}>
                                <TimeSelector
                                    interval={5}
                                    id="new_template_endtime"
                                    cssClass="rounded"
                                    date={this.props.Model.get("HourEnd")}
                                    disabled={false}
                                    onSelectOp={LocalOperations.CreateTemplateTab.OnHourEndChange}
                                    isRequired
                                    dataCy="template-to"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {this.props.Model.get("CreateScheduleTypeCode") === OpenSheduleType.Service.toString() && (
                    this.renderTemplateService()
                )}
                {this.props.Model.get("CreateScheduleTypeCode") === OpenSheduleType.RuleSet.toString() && (
                    this.renderTemplateRuleSet()
                )}

                <div style={s.row}>
                    <div style={s.c1} />
                    <div style={s.c2} />
                </div>
            </div>
        );
    }

    private renderTemplateService(): JSX.Element {
        var self = this;
        var s = this;

        return (
            <>
                <div style={s.row} data-cy="template-services">
                    <div style={s.c1}>
                        <div style={s.divlabel}>
                            <label style={s.label}> {cacheStore.GetString("ServicesLabel")} </label>
                        </div>
                    </div>
                    <div style={s.c2}>
                        {this.state.SelectedService == null && (
                            <TextboxControl
                                value=""
                                autoCompleteItems={this.state.ServicesFiltered}
                                onAutoCompleteSelectCallBack={(code, value: ServiceDefinitionModel) => {
                                    self.mutateState((_state: CreateTemplateTabViewState) => {
                                        _state.SelectedService = cloneDeep(value);
                                    });
                                }}
                                onAutoCompleteSelectClearTextBox={false}
                                style={{ marginRight: "10px" }}
                                placeholder=""
                                dataCy="template-serviceSelect"
                            />
                        )}
                        {this.state.SelectedService != null && (
                            <div className="flex-container" style={{ justifyContent: "flex-start" }}>
                                <div style={{ marginRight: "10px", marginTop: "9px" }}>{cacheStore.GetLocalizedValueByLookupId(this.state.SelectedService.Model.SpecializationLookupId) + " - " + this.state.SelectedService.Name + " (" + this.state.SelectedService.GetDefaultDurationMinutes() + " min.)"}</div>
                                <div
                                    className="open-schedule-redx pointer margin-sm-top"
                                    onClick={() => {
                                        self.mutateState((_state: CreateTemplateTabViewState) => {
                                            _state.SelectedService = null;
                                        });
                                    }}
                                >
                                    <span>X</span>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {this.state.SelectedService && cacheStore.ClinicSettings.EnableOnlinePredefinedAppointments && (
                    <EditServiceOptions
                        selectedService={this.state.SelectedService}
                        onIsOnlineChange={isOnline => this.mutateState(_state => _state.SelectedService.Model.IsAvailableOnline = isOnline)}
                        onTargetedClientChange={targetedClient => this.mutateState(_state => _state.SelectedService.Model.OnlineClienenteleCible = targetedClient)}
                    />
                )}
            </>
        );
    }

    private renderTemplateRuleSet(): JSX.Element {
        var s = this;

        return (
            <div>
                <div style={s.row}>
                    <div style={s.c1}>
                        <div style={s.divlabel}>
                            <label style={s.label}>{cacheStore.GetString("ServicesLabel")}</label>
                        </div>
                    </div>
                    <div style={{ paddingLeft: "10px" }}>
                        <ButtonGroup>
                            <ButtonControl
                                variant="neutral"
                                onClick={() => sessionStore.dispatch(LocalOperations.CreateTemplateTab.StartOver)}
                                label={cacheStore.GetString("StartOverLabel")}
                                dataCy="template-startOver"
                            />
                            <ButtonControl
                                variant="brand"
                                onClick={this.onAddServicesPopupClick.bind(this)}
                                label={cacheStore.GetString("AddServicesLabel")}
                                dataCy="template-addServices"
                            />
                        </ButtonGroup>
                    </div>
                </div>
                {this.props.Model.get("InitialSelectedServiceComboList") != null && this.props.Model.get("InitialSelectedServiceComboList").size > 0 && (
                    <RulesetEditComponent
                        selectedComboServiceList={this.props.Model.get("InitialSelectedServiceComboList")}
                        notifyParentCurrentStateChanged={ruleSetDTO => this.updateOnChildChange(ruleSetDTO)}
                    />
                )}
            </div>

        );
    }

    private renderMiddle(): JSX.Element {
        return (
            <div style={this.Middle}>
                {(this.props.Model.get("CreateScheduleTypeCode") === OpenSheduleType.Service.toString() || this.props.Model.get("CreateScheduleTypeCode") === OpenSheduleType.RuleSet.toString()) && (
                    <div className={styles.addDeleteButtonContainer}>
                        {/** addDeleteButtonContainer css class makes it so the width of the following buttons are the same. Need to fix this once Design system has label button. */}
                        <ButtonControl
                            variant="brand"
                            disabled={this.isAddButtonDisabled()}
                            onClick={() => this.handleOnClickAdd()}
                            label={cacheStore.GetString("AddLabel") + " >>"}
                            dataCy="template-addService"
                        />
                        <ButtonControl
                            variant="error"
                            disabled={this.props.Model.get("WorkDayList").size === 0}
                            onClick={() => this.onDeleteClick()}
                            label={"<< " + cacheStore.GetString("DeleteLabel")}
                            dataCy="template-deleteService"
                        />
                    </div>
                )}
            </div>
        );
    }

    private renderRight(): JSX.Element {
        return (
            <div style={this.RightSide}>
                <div className="flex-container" style={{ justifyContent: "flex-end", marginBottom: "15px", marginRight: "10px" }}>
                    <div className="text-right">
                        <ButtonGroup>
                            <ButtonControl
                                variant="neutral"
                                onClick={this.onCancelClick.bind(this)}
                                label={cacheStore.GetString("CancelLabel")}
                            />
                            <ButtonControl
                                variant="brand"
                                disabled={IsNullOrWhiteSpace(this.props.Model.get("Name")) || this.props.Model.get("WorkDayList").size === 0}
                                onClick={() => this.onSaveClick()}
                                label={cacheStore.GetString("SaveLabel")}
                                dataCy="template-save"
                            />
                        </ButtonGroup>
                    </div>
                </div>
                <div>
                    <AppointmentSchedulerV2
                        workDays={this.props.Model.get("WorkDayList")}
                        minorAxisResolutionInMinutes={15}
                        fullWidth={false}
                        showXForDelete={true}
                        onSelectRulesetOperation={LocalOperations.CreateTemplateTab.SelectExistingRuleset}
                        deleteSinglePredefinedAppointmentOrRuleSetFunction={this.onDeleteSinglePredefinedAppointmentOrRuleSet.bind(this)}
                    />
                </div>
            </div>
        );
    }

    private renderHeaderRow(): JSX.Element {
        return (
            <div className="myle-workspace-header" style={{ "padding": "9px" }}>
                <div className="row">
                    <div className="col-lg-4 col-md-5 col-sm-5 hidden-sm-down">
                        <h3 className="thin-font">{cacheStore.GetString("CreateTemplateLabel")}</h3>
                    </div>
                </div>
            </div>
        );
    }

    private isAddButtonDisabled(): boolean {
        const hourStart = this.props.Model.get("HourStart");
        const hourEnd = this.props.Model.get("HourEnd");
        const serviceType = this.props.Model.get("CreateScheduleTypeCode");
        const duration = hourEnd.valueOf() - hourStart.valueOf();
        const fiveMinutesInMiliSeconds = 30000;

        if (serviceType === OpenSheduleType.Service.toString() && !this.state.SelectedService ||
            (serviceType === OpenSheduleType.RuleSet.toString() && (this.props.Model.get("ComboServiceList") == null || this.props.Model.get("ComboServiceList").size == 0 || duration < fiveMinutesInMiliSeconds)))
            return true;
        else
            return false;
    }

    private handleOnClickAdd(): void {
        const serviceType = this.props.Model.get("CreateScheduleTypeCode");
        if (serviceType === OpenSheduleType.Service.toString())
            return this.onAddClick();
        else if (serviceType === OpenSheduleType.RuleSet.toString())
            return this.calculateTotalMinAndMax();
    }

    private mutateState(mutate: (state: CreateTemplateTabViewState) => void): void {
        var state = new CreateTemplateTabViewState();
        state = this.state;
        mutate(state);
        this.setState(state);
    }

    private onAddClick(): void {
        var op = new LocalEvent(LocalOperations.CreateTemplateTab.AddPredefinedTemplate);
        op.AddItem("service", cloneDeep(this.state.SelectedService));
        LocalEventDispatcher.dispatch(op);
    }

    private onDeleteClick(): void {
        LocalEvent.Dispatch(LocalOperations.CreateTemplateTab.OnDeleteClick);
    }

    private onSaveClick(): void {
        if (this.props.Model.get("IsFromEdit") === false)
            LocalEvent.Dispatch(LocalOperations.CreateTemplateTab.SavePredefinedTemplate);
        else if (this.props.Model.get("IsFromEdit") === true)
            LocalEvent.Dispatch(LocalOperations.CreateTemplateTab.SaveEditionPredefinedTemplate);
    }

    private onCancelClick(): void {
        LocalEvent.Dispatch(LocalOperations.CreateTemplateTab.CancelClick);
    }

    private onTypeChange(value: string): void {
        var op = new LocalEvent(LocalOperations.CreateTemplateTab.ChangeTypeCode);
        op.AddItem("type", value);
        LocalEventDispatcher.dispatch(op);

        let s = new CreateTemplateTabViewState(this.state);
        this.setState(s);
    }

    private onAddServicesPopupClick(): void {
        LocalEvent.Dispatch(LocalOperations.CreateTemplateTab.OpenAddServicePopup);
    }

    private onAddServiceClick(): void {
        LocalEvent.Dispatch(LocalOperations.CreateTemplateTab.AddRuleSetService);
    }

    private calculateTotalMinAndMax(): void {
        let s = new CreateTemplateTabViewState(this.state);
        let minMaxResults = SchedulerHelper.calculateTotalMinAndMax(this.props.Model.get("ComboServiceList").toArray(), this.props.Model.get("HourStart"), this.props.Model.get("HourEnd"));

        if (!minMaxResults.MinimumsValid) {
            s.MinErrorPopupOpen = true;
            this.setState(s);
            sessionStore.showGlobalOverlay(true);
        }
        else {
            LocalEvent.Dispatch(LocalOperations.CreateTemplateTab.PrepareRuleSetSave);
        }
    }

    private closeMinErrorPopup(): void {
        let s = new CreateTemplateTabViewState(this.state);

        s.MinErrorPopupOpen = false;
        this.setState(s);

        sessionStore.hideGlobalOverlay();
    }

    private closeMaxErrorPopup(): void {
        let s = new CreateTemplateTabViewState(this.state);

        s.MaxErrorPopupOpen = false;
        this.setState(s);

        sessionStore.hideGlobalOverlay();
    }

    private onDeleteSinglePredefinedAppointmentOrRuleSet(slot: CalendarSlotV2): void {
        var op = new LocalEvent(LocalOperations.CreateTemplateTab.DeleteItemFromNewTemplate);
        op.AddItem("item", slot);
        LocalEventDispatcher.dispatch(op);
    }

    private updateOnChildChange(ruleSetDTO: RulesetEditComponentDTO): void {
        var op = new LocalEvent(LocalOperations.CreateTemplateTab.UpdateSelectedComboServicesOnChanges);
        op.AddItem("item", ruleSetDTO.selectedComboServiceList);
        LocalEventDispatcher.dispatch(op);
    }

    private getServicesFilteredBySiteId(siteId: string): Immutable.List<SearchableItemModelT<ServiceDefinitionModel>> {
        return cacheStore.ServiceDefinitionCache.toArray()
            .filter(c => c.GetSiteId() === siteId && c.Employees.length > 0 && !c.IsAdHoc)
            .map(c => new SearchableItemModelT<ServiceDefinitionModel>(cacheStore.GetLocalizedValueByLookupId(c.GetSpecializationId()) + " - " + c.Name + " (" + c.GetDefaultDurationMinutes() + " min. )", c.Model.Id, c)).toImmutable();
    }
}

export { CreateTemplateTabView, CreateTemplateTabViewState };
